import { createContext, useContext, useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import React from 'react';

export const dataExplorerHistoryContext = createContext({ path: '' });
export const useDataExplorerHistory = () => {
  const { path: parentPath } = useContext(dataExplorerHistoryContext);
  const history = useHistory();
  const dataExplorerHistory = useMemo(
    () => ({
      ...history,
      push: (path: string) => {
        history.push(parentPath + path);
      },
    }),
    [parentPath, history]
  );

  return dataExplorerHistory;
};

export const DataExplorerLink: typeof Link = props => {
  const { path } = useContext(dataExplorerHistoryContext);
  return <Link {...props} to={path + props.to} />;
};
